import {
  Button,
  ButtonGroup,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  Menu,
  MenuItem,
  OutlinedInput,
  TextField,
} from "@mui/material";
import CachedIcon from "@mui/icons-material/Cached";
import { useMaterialUIController } from "context";
import { useEffect, useState } from "react";
import getText from "Translator";
import AddIcon from "@mui/icons-material/Add";
import HistoryIcon from "@mui/icons-material/History";
import CloseIcon from "@mui/icons-material/Close";
import SettingsBackupRestoreIcon from "@mui/icons-material/SettingsBackupRestore";
import Swal from "sweetalert2";
import { deleteHistory } from "controllers/PageController";
import { setLoading } from "context";
const ITEM_HEIGHT = 48;

let delay = 800;
let startPress = null;
let clearError = false;
export default function NumberComponent(props) {
  const {
    question,
    disabled,
    editQuestionHandle,
    helpPage,
    autoFocus,
    setFocuse,
    insertHistoryHandler,
  } = props;
  const [error, setError] = useState(false);
  const [inHistoryMode, setInHistoryMode] = useState(false);
  const [deleteMode, setDeleteMode] = useState(false);
  const [val, setVal] = useState(question.useranswer);
  const [controller, dispatch] = useMaterialUIController();
  const renderAllowCopy = () => {
    return (
      <CachedIcon
        onClick={async () => {
          if (question.useranswer == question.copyValue) {
            editQuestionHandle(question, "");
          } else {
            editQuestionHandle(question, question.copyValue);
          }
        }}
        style={{
          color: "#BD4941",
          height: 20,
          width: 25,
          marginTop: -50,
          marginInlineEnd: -20,
          cursor: "pointer",
          zIndex: 999,
        }}
      />
    );
  };

  const handleClick = async (event) => {
    if (question.history && question.history.length > 0) {
      setFocuse(question.code);
      setInHistoryMode(true);
      if (val) {
        let result = await insertHistoryHandler(question, val);
        if (result) {
          setVal("");
        }
      }
    }
    // setAnchorEl(event.currentTarget);
  };

  useEffect(() => {
    if (question.history && question.history.length > 0) {
      setFocuse(question.code);
      setInHistoryMode(true);
    }
  }, []);

  async function DeletehistoryHandler(item) {
    console.log(item);
    Swal.fire({
      title: getText("warning", controller.lang),
      html: `${getText("deleteconfirm", controller.lang)} <h3>${
        item.answer
      } </h3>`,
      confirmButtonText: getText("yes", controller.lang),
      cancelButtonText: getText("no", controller.lang),
      showCancelButton: true,
    }).then(async (result) => {
      if (result.isConfirmed) {
        setLoading(dispatch, true);
        let deleteResult = await deleteHistory(item, controller.token);
        setLoading(dispatch, false);
        if (deleteResult.success) {
          question.history = question.history.filter(
            (a) => a._id + "" !== item._id + ""
          );

          Swal.fire({
            text: getText("alertsuccess", controller.lang),
            position: "bottom-end",
            background: "#03fca1",
            showConfirmButton: false,
            timer: 1500,
          });

          setInHistoryMode(false);
          let historyCount = await question.history.filter(
            (a) => a._id + "" !== item._id + ""
          );
          setDeleteMode(false);
          if (historyCount.length > 0) {
            setTimeout(() => {
              setInHistoryMode(true);
            }, 100);
          }
        } else {
          Swal.fire({
            text: getText("warningalert", controller.lang),
            position: "bottom-end",
            background: "#f1b3af",
            showConfirmButton: false,
            timer: 1500,
          });
        }
      } else {
        setDeleteMode(false);
      }
    });
  }

  return (
    <Grid
      item
      xs={
        question.fixTop || question.fixBottom
          ? 12
          : question.size
          ? question.size
          : 12
      }
      sm={
        question.fixTop || question.fixBottom
          ? 12
          : question.size
          ? question.size
          : 12
      }
      md={
        question.fixTop || question.fixBottom
          ? 12
          : question.size
          ? question.size
          : 12
      }
      style={{
        position: question.fixTop || question.fixBottom ? "fixed" : "unset",
        left: question.fixTop || question.fixBottom ? 0 : "unset",
        right: question.fixTop || question.fixBottom ? 0 : "unset",
        top: question.fixTop ? 0 : "unset",
        bottom: question.fixBottom ? 0 : "unset",
        paddingBottom: question.fixTop || question.fixBottom ? 10 : "unset",
        backgroundColor:
          question.fixTop || question.fixBottom ? "#FFF" : "unset",
        zIndex: question.fixTop || question.fixBottom ? 999 : "unset",
        paddingTop: question.fixTop ? 55 : question.fixBottom ? 10 : "unset",
        paddingBottom: question.fixBottom ? 55 : question.fixTop ? 10 : "unset",
        paddingRight: question.fixTop || question.fixBottom ? 15 : "unset",
        paddingLeft: question.fixTop || question.fixBottom ? 15 : "unset",

        marginTop:
          question.titleType === 2 ? 8 : question.displayTitle ? -3 : 8,
        marginBottom:
          question.helpPage && inHistoryMode ? -7 : inHistoryMode ? 7 : 0,
        display: question.visible ? "" : "none",
        paddingInlineEnd: question.size && question.size !== 12 ? 3 : "unset",
      }}
    >
      {question.displayTitle && question.titleType === 1 && (
        <div onClick={handleClick}>
          <b>{question.text}</b>
        </div>
      )}
      {question.allowCopy && question.copyValue && renderAllowCopy()}
      <TextField
        autoFocus={autoFocus}
        key={`rangetext${question.code}`}
        InputLabelProps={{
          shrink: true,
        }}
        type="number"
        variant="outlined"
        label={
          question.displayTitle && question.titleType === 2 ? (
            <div onClick={handleClick}> {question.text}</div>
          ) : (
            ""
          )
        }
        disabled={disabled}
        style={{
          backgroundColor:
            error || (!clearError && question.error) ? "#f3bab6" : "inherit",
        }}
        fullWidth={true}
        value={val}
        placeholder={question.tooltip}
        onTouchStart={() => {
          setFocuse(question.code);
        }}
        onMouseDown={() => {
          setFocuse(question.code);
        }}
        onChange={(event) => {
          setVal(event.target.value);
        }}
        onBlur={(event) => {
          let minValue = question.answers[0].answer;
          let maxValue = question.answers[1].answer;

          console.log(
            "ql.useranswerql.useranswerql.useranswer",
            minValue,
            maxValue,
            val
          );
          if (
            val &&
            (parseFloat(val) >= parseFloat(minValue) &&
              parseFloat(val) <= parseFloat(maxValue)) === false
          ) {
            let message =
              question.text +
              " : " +
              getText("answernotinrange", "fa") +
              "<br />";
            Swal.fire({
              title: getText("warning", controller.lang),
              html: message,
            });
            return;
          }

          editQuestionHandle(question, event.target.value);
          setFocuse(question.code);
        }}
        // onTouchStart={() => {
        //   setFocuse(question.code);
        // }}
        onSelect={() => {
          setFocuse(question.code);
        }}
        InputProps={
          !inHistoryMode && {
            startAdornment: (
              <InputAdornment position="start">
                <IconButton
                  title="add to history"
                  style={{ padding: 0 }}
                  id="long-button-x"
                  onClick={async () => {
                    if (val) {
                      let result = await insertHistoryHandler(question, val);
                      if (result) {
                        setVal("");
                      }
                    }
                  }}
                >
                  <AddIcon style={{ width: 20, color: "#bd4941" }} />
                </IconButton>
              </InputAdornment>
            ),
          }
        }
      />
      {inHistoryMode && (
        <Grid
          item
          style={{
            position: "relative",
            marginTop: -40,
            fontSize: 14,
            minWidth: "98%",
            maxWidth: "98%",
            backgroundColor: "#f2f2f2",
            right: controller.direction == "rtl" ? 5 : "unset",
            left: controller.direction == "ltr" ? 5 : "unset",
            overflow: "scroll",
          }}
          onClick={() => {
            if (!startPress && startPress !== null) {
              setVal("");
              setInHistoryMode(false);
            }
          }}
        >
          <div
            style={{
              display: "inline-flex",
              width: "100%",
              height: 35,
              direction: "rtl",
              overflow: "scroll",
            }}
          >
            {!deleteMode && (
              <IconButton
                title="add to history"
                style={{ marginInlineEnd: 8 }}
                id="long-button-x"
                onClick={async () => {
                  setDeleteMode(!deleteMode);
                }}
              >
                <CloseIcon style={{ width: 20, color: "#bd4941" }} />
              </IconButton>
            )}
            {deleteMode && (
              <IconButton
                title="add to history"
                style={{ marginInlineEnd: 8 }}
                id="long-button-x"
                onClick={async () => {
                  setDeleteMode(!deleteMode);
                }}
              >
                <SettingsBackupRestoreIcon
                  style={{ width: 20, color: "#bd4941" }}
                />
              </IconButton>
            )}
            {question.history.map((option) => (
              <div style={{ display: "flex" }}>
                {deleteMode && (
                  <IconButton
                    style={{ padding: 0, position: "absolute", height: 40 }}
                    title="add to history"
                    id="long-button-x"
                    onClick={async () => {
                      DeletehistoryHandler(option);
                    }}
                  >
                    <CloseIcon style={{ width: 30, color: "#bd4941" }} />
                  </IconButton>
                )}
                <div
                  style={{
                    textAlign: "center",
                    overflow: "hidden",
                    marginInlineEnd: 8,
                    justifyContent: "space-between",
                    minWidth: 35,
                  }}
                  onClick={() => {
                    setVal("");
                    setInHistoryMode(false);
                  }}
                >
                  {` ${option.answer} `}
                  <br />
                  <div
                    style={{
                      textAlign: "center",
                      fontSize: 11,
                    }}
                  >
                    {`${option.createdAt.substring(5, 10)} `}
                  </div>
                </div>
              </div>
            ))}
          </div>
          {/* <div
            style={{
              display: "flex",
              flex: 1,
              flexDirection: "row",
            }}
          >
            {question.history.map((option) => (
              <div
                style={{
                  width: 35,
                  minWidth: 35,
                  maxWidth: 35,
                  fontSize: 11,
                  maxHeight: 18,
                  height: 18,
                  backgroundColor: "#f2f2f2",
                  overflow: "hidden",
                  textAlign: "center",
                  marginInlineEnd: 5,
                  marginTop: -5,
                  justifyContent: "space-between",
                }}
                onTouchStart={() => mouseDown()}
                onTouchEnd={() => mouseUp(option)}
                onMouseDown={() => mouseDown()}
                onMouseUp={() => mouseUp(option)}
                onClick={() => {}}
              >
                {` ${option.createdAt.substring(5, 10)}   `}
              </div>
            ))}
          </div> */}
        </Grid>
      )}
      {question.helpPage && (
        <Button
          style={{
            marginTop: -10,
          }}
          onClick={() => {
            helpPage(question.helpPage);
          }}
          className="helplink"
          fullWidth={true}
        >
          <div
            style={{
              width: "100%",
              fontSize: 11,
              textAlign: controller.lang == "fa" ? "left" : "right",
            }}
          >
            {question.helpText === ""
              ? getText("helptext", controller.lang)
              : question.helpText}
          </div>
        </Button>
      )}
    </Grid>
  );
}
